import { render } from "./MethodsListLabel.vue?vue&type=template&id=5c82d518&lang=pug"
import script from "./MethodsListLabel.vue?vue&type=script&lang=js"
export * from "./MethodsListLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__